import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import theme from "../theme";

export const SelectedFilterListWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding-bottom: 8px;
  flex-wrap: wrap;
`;

export const SelectedFilterListItem = styled(Box)`
  padding: 0 8px;
  background: #f0f2f5;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  gap: 2px;
  height: 32px;
  align-items: center;
`;

export const FilterBy = styled(Typography)`
  font-size: 15px;
  color: ${theme.palette.secondary.dark};
`;
